import type { Tables } from "@/gestionale/integrations/supabase/types";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/gestionale/components/ui/alert-dialog";

interface Props {
  persona: Tables<"persone"> | null;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export default function DeletePersonaDialog({ persona, onOpenChange, onConfirm, isDeleting }: Props) {
  return (
    <AlertDialog open={!!persona} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminare questa persona?</AlertDialogTitle>
          <AlertDialogDescription>
            Stai per eliminare <strong>{persona?.nome} {persona?.cognome}</strong>. Questa azione non può essere annullata.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Eliminazione..." : "Elimina"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
